import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Library from "@/pages/Library";
import Konto from "@/pages/Konto";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/konto/*" element={<Konto />} />
          <Route path="/bibliotek" element={<Library />} />
          <Route path="/" element={<Navigate to="/konto" replace />} />
          <Route path="*" element={<Navigate to="/konto" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
